import React, { useCallback } from 'react';
import { RadioButton } from '@vectord/components';
import classNames from 'classnames';

import { CONTEST_TYPES } from '@classCreation/data/contestTypes';
import styles from './ContestTypeInput.module.scss';

export default function ContestTypeInput({ onChange, value, className }) {
  const handleChange = useCallback(
    (event) => {
      onChange(event.target.name);
    },
    [onChange]
  );

  return (
    <div className={classNames(styles.input, 'm-t-s', className)}>
      <RadioButton
        active={value === CONTEST_TYPES.group}
        name={CONTEST_TYPES.group}
        text="Group Contest"
        textClassName={styles.text}
        onChange={handleChange}
      />
      <RadioButton
        active={value === CONTEST_TYPES.single}
        name={CONTEST_TYPES.single}
        text="Single Contest"
        textClassName={styles.text}
        onChange={handleChange}
      />
    </div>
  );
}
